// Tools
const ft = require("../Tools/FileTools");

export class PlayerScheduleManager {
  constructor(pathToProjects) {
    this.path = pathToProjects;
    this.currentProjectRead = null;
    this.previousProject = null;
  }

  getCurrentProjectRead() {
    return this.path + this.currentProjectRead.name;
  }

  isThereNewProject() {
    if (this.currentProjectRead != null && this.currentProjectRead != this.previousProject) {
      return true;
    }
    return false;
  }

  /**
   * Retrieve the last schedule from the folder this.path and store it in this.currentProjectRead
   */
  async retrieveLastFile() {
    const scheduleName = "scheduleManager.json";
    this.previousProject = this.currentProjectRead;

    // Get all files from readingDirectory
    await ft
      .exists(this.path + scheduleName)
      .then((response) => {
        if (response) {
          this.currentProjectRead = { name: scheduleName };
        } else {
          this.currentProjectRead = null;
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
